import { BaseService, Service } from "/@/cool";

@Service("openapiCustomerSettle")
class OpenapiCustomerSettle extends BaseService {
	constructor() {
		super();
		const prefix = this.namespace ? this.namespace.replace(/\//g, ":") + ":" : "";
		this.permission["statementPage"] = prefix + "statementPage";
		this.permission["statementExport"] = prefix + "statementExport";
		this.permission["amountDetail"] = prefix + "amountDetail";
	}

	statementPage(data: Record<string, any>) {
		return this.request({
			url: "/statementPage",
			method: "POST",
			data
		});
	}

	statementExport(data: Record<string, any>) {
		return this.request({
			url: "/statementExport",
			method: "POST",
			data,
			responseType: "blob",
			timeout: 300000
		});
	}

	amountDetail(data: Record<string, any>) {
		return this.request({
			url: "/amountDetail",
			method: "POST",
			data
		});
	}
}

export default OpenapiCustomerSettle;
